export default __webpack_public_path__ + "static/thumb-landscape-2388ff89222376ddecee4e9013f080ce.png";